<template>
  <brazil-v-dialog
    id="positive-credit-data-consent-modal"
    header="AUTORIZAÇÃO PARA DISPONIBILIZAÇÃO DE HISTÓRICO DE CRÉDITO"
    :value="showDialog"
    @change="closeModal"
  >
    <!-- eslint-disable max-len -->
    <section id="positive-credit-data-consent-modal-body">
      <ol>
        <li>
          Autorizo os gestores de banco de dados de que trata a <a
            href="http://www.planalto.gov.br/ccivil_03/_Ato2011-2014/2011/Lei/L12414.htm"
            target="_blank"
          >Lei nº 12.414, de 9 de junho de 2011</a>, a disponibilizar à <strong>LH1010 Serviços de Correspondente Bancário Ltda., CNPJ 17.103.297/0001-13 e LH1003 Serviços de Dados Ltda., CNPJ 17.102.504/0001-15 (Simplic)</strong>, o meu histórico de crédito, o qual abrangerá os dados financeiros e de pagamentos relativos às operações de crédito e obrigações de pagamento adimplidas em seus respectivos vencimentos, e aquelas a vencer, constantes de banco(s) de dados, com a finalidade única e exclusiva de subsidiar a análise e a eventual concessão de crédito, a venda a prazo ou outras transações comerciais e empresariais que impliquem risco financeiro.
        </li>
        <li>Esta autorização tem validade de até 3 (três) meses a contar da presente data.</li>
        <li>Estou ciente de que poderei revogar, a qualquer tempo, esta autorização, perante o gestor de banco de dados.</li>
      </ol>
    </section>
    <!-- eslint-enable max-len -->
  </brazil-v-dialog>
</template>
<script>
import BrazilVDialog from './BrazilVDialog.vue';

export default {
  name:       'PositiveCreditDataConsentModal',
  components: { BrazilVDialog },
  props:      {
    showDialog: {
      type:    Boolean,
      default: false,
    },
  },
  methods: {
    closeModal(value) {
      if (!value) {
        this.$emit('closeModal');
      }
    },
  },
};
</script>
<style lang="scss">
  #positive-credit-data-consent-modal {
    .dialog-content-container {
      padding: 1em;
    }
  }
  #positive-credit-data-consent-modal-body {
    padding: 2em;
    line-height: 1.5;
    li {
      margin-bottom: 1em;
    }
  }
</style>
